<template>
  <div class="Flavour" :class="classes">
    <div class="Flavour__background"></div>
    <Page>
      <div v-if="theme" class="Flavour__content">
        <transition name="u-fade-in">
          <img
            v-if="show.logo"
            class="Flavour__logo"
            alt="The Glenlivet Spectra Flavour"
            :src="require(`../assets/flavour-${theme}-logo.png`)"
          />
        </transition>
        <div>
          <transition name="u-fade-in">
            <p v-if="show.intro" class="Flavour__intro">
              Tap the 3 most prominent flavours
            </p>
          </transition>
          <nav-box
            v-if="show.navBox"
            @animation-end="continueAnimation"
            @checkActiveStates="activeStates"
            :theme="theme"
            :active-number="activeStates().length"
            :data="flavours[theme]"
          />
        </div>
        <transition name="u-fade-in">
          <base-button
            v-if="show.cta"
            :theme="theme"
            :disabled="isDisabled"
            @click="onNext"
            wide
            >Next</base-button
          >
        </transition>
      </div>
    </Page>
  </div>
</template>

<script>
import Page from '../components/Page'
import BaseButton from '../components/BaseButton'
import NavBox from '../components/NavBox'
import { flavourMixin } from '../mixins/flavourMixin'
import { audioMixin } from '../mixins/audioMixin'

export default {
  components: { NavBox, BaseButton, Page },
  mixins: [flavourMixin, audioMixin],
  data() {
    return {
      theme: 'orchard',
      show: {
        logo: false,
        intro: false,
        navBox: false,
        cta: false
      },
      transitionDuration: 0,
      transitionDelay: 100
    }
  },
  computed: {
    isDisabled() {
      if (this.theme) {
        return this.activeStates().length < 3
      }
      return false
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.updateFlavourStates()
    this.updateActiveStates()
    this.startAnimation()
  },
  methods: {
    startAnimation() {
      setTimeout(() => {
        this.show.logo = true
      }, (this.transitionDuration += this.transitionDelay))
      setTimeout(() => {
        this.show.intro = true
      }, (this.transitionDuration += this.transitionDelay))
      setTimeout(() => {
        this.show.navBox = true
      }, (this.transitionDuration += this.transitionDelay))
    },
    continueAnimation() {
      setTimeout(() => {
        this.show.cta = true
      }, (this.transitionDuration += this.transitionDelay))
    },
    onNext() {
      const activeNames = this.activeStates().map(item => item.name)
      // Go to Intensity page (range sliders)
      this.$router.push({
        path: 'intensity',
        query: {
          theme: this.theme,
          flavours: activeNames.join() // convert to string so we can use in URL
        }
      })
      // this.playSound('intensity')
    }
  }
}
</script>

<style lang="scss">
@import '../scss/variables.scss';
@import '../scss/mixins.scss';
@import '../scss/flavour.scss';
</style>
